import styled from "styled-components";
export const Label = styled.label`
  color: ${props => props.theme.colors.labelTextDefault};
  display: flex;
  flex-flow: column wrap;
  font-size: 15px;
  line-height: 22px;
  font-weight: 400;
  ${props => props.theme.fonts.default};
`;